import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, memo, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Loader } from '../Loader';
import { Group, Wrapper } from './styled';
const Icon = memo(function Icon({ icon, color }) {
    return cloneElement(icon, {
        color,
        size: 16,
    });
});
const BadgeComponent = memo(function BadgeComponent({ className, title, icon, informative, positive, warning, critical, xs, as, to, isLoading, onClick, onDoubleClick, dataTestId, }) {
    const { colors } = useTheme();
    const isInteractive = !isLoading && (!!onClick || !!onDoubleClick || !!to);
    const handleClick = !isLoading ? onClick : undefined;
    const handleDoubleClick = !isLoading ? onDoubleClick : undefined;
    const variantColors = useMemo(() => {
        if (informative) {
            return { bg: colors.link10, text: colors.link120, border: colors.link30 };
        }
        if (positive) {
            return { bg: colors.positive10, text: colors.positive120, border: colors.positive30 };
        }
        if (warning) {
            return { bg: colors.warning10, text: colors.warning120, border: colors.warning30 };
        }
        if (critical) {
            return { bg: colors.critical10, text: colors.critical120, border: colors.critical30 };
        }
        return { bg: colors.grey10_5, text: colors.black_1, border: colors.grey30_1 };
    }, [colors, informative, positive, warning, critical]);
    return (_jsxs(Wrapper, { className: className, $xs: xs, as: as, to: to, $interactive: isInteractive, $variantColors: variantColors, onClick: handleClick, onDoubleClick: handleDoubleClick, "data-testid": dataTestId, children: [isLoading && _jsx(Loader, { cover: true }), icon && _jsx(Icon, { icon: icon, color: variantColors.text }), title] }));
});
export const Badge = Object.assign(BadgeComponent, {
    Group,
});
